const translations = {
    addGrower: 'Add Grower'
};

export default translations;
